"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabInfoSchema = void 0;
var zod_1 = require("zod");
exports.TabInfoSchema = zod_1.z.object({
    items: zod_1.z.array(zod_1.z.object({
        key: zod_1.z.string(),
        title: zod_1.z.string(),
        selected: zod_1.z.boolean(),
        isDefault: zod_1.z.boolean().nullish(),
        serverLogMeta: zod_1.z.record(zod_1.z.unknown()).nullish(),
    })),
});
